import { createContext, useContext, useState, useCallback } from "react";

const ParentDrawerContext = createContext(null);

export function ParentDrawerProvider({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const openDrawer = useCallback(() => setDrawerOpen(true), []);
  const closeDrawer = useCallback(() => setDrawerOpen(false), []);
  const toggleDrawer = useCallback(() => setDrawerOpen(v => !v), []);

  return (
    <ParentDrawerContext.Provider value={{ drawerOpen, openDrawer, closeDrawer, toggleDrawer }}>
      {children}
    </ParentDrawerContext.Provider>
  );
}

export function useParentDrawer() {
  const ctx = useContext(ParentDrawerContext);
  if (!ctx) {
    throw new Error("useParentDrawer doit être utilisé dans un <ParentDrawerProvider>");
  }
  return ctx;
}